import * as React from "react";
import { useState, useMemo } from "react";
import { isPermitted } from "util/PermissionsMixin";
import useCurrentUser from "hooks/useCurrentUser";
import { Button } from "components/bootstrap";
import { DataWell } from "common/components";
import { Icon } from "components/common";
import EvidenceSectionHeader from "security-app/components/Investigations/Details/OverviewSegment/EvidenceSectionHeader";
import LogsModal from "./LogsModal";
import LogsList from "./LogsList";
function Logs({ investigation, isExpanded, onToggleExpanded }) {
  const { permissions } = useCurrentUser();
  const [showAddModal, setShowAddModal] = useState(false);
  const canManageEvidence = useMemo(
    () => !investigation.archived && isPermitted(permissions, "investigations:edit"),
    [investigation.archived, permissions]
  );
  return /* @__PURE__ */ React.createElement(DataWell, { $color: "content" }, /* @__PURE__ */ React.createElement(
    EvidenceSectionHeader,
    {
      sectionName: "logs",
      title: "Logs",
      count: investigation.logs_count,
      isExpanded,
      onToggleExpanded,
      action: canManageEvidence ? /* @__PURE__ */ React.createElement(Button, { onClick: () => setShowAddModal(true) }, /* @__PURE__ */ React.createElement(Icon, { name: "add", size: "sm" }), "Add Logs") : null
    }
  ), isExpanded && /* @__PURE__ */ React.createElement("div", { style: { marginTop: "0.5rem" } }, /* @__PURE__ */ React.createElement(LogsList, { investigation })), /* @__PURE__ */ React.createElement(LogsModal, { show: showAddModal, onCancel: () => setShowAddModal(false) }));
}
export default Logs;
